import React, { useEffect, useState } from 'react';
import api from '../services/api';
import UserMenu from '../components/UserMenu';
import AjustesMenu from '../components/AjustesMenu';
import { getUserFromStorage } from '../services/auth';
import './PerfilAmpliaciones.css'; // Asegúrate de tener este archivo CSS

function PerfilAmpliaciones() {
  const perfil = JSON.parse(localStorage.getItem('perfilActual'));
  const user = getUserFromStorage();
  const [ampliaciones, setAmpliaciones] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [meses, setMeses] = useState(1);
  const [observaciones, setObservaciones] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!perfil?.id || !user?.id) {
      setError('No se ha podido identificar el perfil. Redirigiendo...');
      setTimeout(() => {
        localStorage.removeItem('perfilActual');
        window.location.href = '/seleccionar-perfil';
      }, 2000);
      return;
    }
    cargarAmpliaciones();
  }, []);

  const cargarAmpliaciones = async () => {
    try {
      setCargando(true);
      const res = await api.get(`/ampliaciones/perfil/${perfil.id}`);
      setAmpliaciones(res.data);
      setError('');
    } catch (err) {
      console.error('Error al cargar ampliaciones:', err);
      setError('Error al cargar ampliaciones. Intenta recargar la página.');
    } finally {
      setCargando(false);
    }
  };

  const enviarAmpliacion = async () => {
    setError('');

    if (!perfil?.id || !user?.id) {
      setError('No se ha podido identificar el perfil. Cierra sesión e intenta de nuevo.');
      return;
    }

    if (meses < 1 || meses > 12) {
      setError('Elige entre 1 y 12 meses');
      return;
    }

    const yaPendiente = ampliaciones.some((a) => a.estado === 'pendiente');
    if (yaPendiente) {
      setError('Ya tienes una solicitud pendiente. Espera a que sea gestionada.');
      return;
    }

    try {
      setCargando(true);
      await api.post('/ampliaciones', {
        user_id: user.id,
        perfil_id: perfil.id,
        meses,
        observaciones
      });
      setMostrarFormulario(false);
      setMeses(1);
      setObservaciones('');
      await cargarAmpliaciones();
    } catch (err) {
      console.error('Error al solicitar ampliación:', err);
      setError(err.response?.data?.message || 'Error al enviar la solicitud.');
    } finally {
      setCargando(false);
    }
  };

  if (!perfil?.id || !user?.id) {
    return (
      <div className="error-container">
        <p className="error-message">{error || 'No se ha podido identificar el perfil'}</p>
        <button 
          className="btn-volver"
          onClick={() => {
            localStorage.removeItem('perfilActual');
            window.location.href = '/seleccionar-perfil';
          }}
        >
          Volver a seleccionar perfil
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="menu-superior">
        <UserMenu />
        <AjustesMenu />
      </div>

      <div style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 2001 }}>
        <AjustesMenu />
      </div>

      <div className="perfil-ampliaciones-container">
        <h2>Mis Ampliaciones</h2>

        {cargando && !mostrarFormulario ? (
          <div className="cargando-container">
            <div className="spinner"></div>
            <p>Cargando ampliaciones...</p>
          </div>
        ) : (
          <>
            <button 
              className={`btn-ampliacion ${mostrarFormulario ? 'btn-cancelar' : ''}`}
              onClick={() => setMostrarFormulario(!mostrarFormulario)}
              disabled={cargando}
            >
              {mostrarFormulario ? 'Cancelar' : 'Solicitar Ampliación'}
            </button>

            {mostrarFormulario && (
              <div className="formulario-ampliacion">
                <div className="form-group">
                  <label>Meses:</label>
                  <input
                    type="number"
                    min={1}
                    max={12}
                    value={meses}
                    onChange={(e) => setMeses(parseInt(e.target.value))}
                    disabled={cargando}
                  />
                </div>
                <div className="form-group">
                  <label>Observaciones:</label>
                  <textarea
                    value={observaciones}
                    onChange={(e) => setObservaciones(e.target.value)}
                    placeholder="Ej. Concepto de la ampliación"
                    disabled={cargando}
                  />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button 
                  className="btn-enviar"
                  onClick={enviarAmpliacion}
                  disabled={cargando}
                >
                  {cargando ? 'Enviando...' : 'Enviar Solicitud'}
                </button>
              </div>
            )}

            {ampliaciones.length === 0 ? (
              <p className="sin-ampliaciones">No has solicitado ninguna ampliación.</p>
            ) : (
              <ul className="lista-ampliaciones">
                {ampliaciones.map((a) => (
                  <li key={a.id} className={`ampliacion-item ${a.estado}`}>
                    <div className="ampliacion-header">
                      <span className="ampliacion-meses">{a.meses} mes(es)</span>
                      <span className="ampliacion-estado">{a.estado}</span>
                      <span className="ampliacion-fecha">
                        {new Date(a.created_at).toLocaleDateString()}
                      </span>
                    </div>
                    {a.observaciones && (
                      <div className="ampliacion-observaciones">
                        <p>📝 {a.observaciones}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default PerfilAmpliaciones;